import React, {Component} from 'react';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {connect} from 'react-redux';
import * as actions from '../actions';
import PropTypes from 'prop-types';

import '../styles/parts/_step-list.scss';

/**
 * Import components
 */
import StepOne from './dwdf-steps/StepOne';
import StepTwo from './dwdf-steps/StepTwo';
import StepThree from './dwdf-steps/StepThree';
import StepFour from './dwdf-steps/StepFour';
import StepFive from './dwdf-steps/StepFive';
import Download from './download/Download';
import SideBarMenu from './SideBarMenu';

import PrevNext from './PrevNext';

import dwdfImage from '../assets/images/dwdf_1.png';
import {setApron} from "../actions";
import {DWDF_STEPS} from "../constants/steps";

class Dwdf extends Component {

	/**
     * constructor method
     * @param props
     */
	// constructor(props) {
	//     super(props)
	// }

    componentDidMount() {
        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.dwdf')}`;
        const breadCrumbThird = this.props.translate('BREADCRUMBS.model');

        this.props.setBreadCrumbs(breadCrumbSecond, breadCrumbThird);

        // set articleID
        this.props.setArticle(this.props.articleID);
    }

    componentDidUpdate() {
        if(!this.props.apron) {
            const isSZ = this.isSZPresent();
            if (!isSZ) {
                this.props.setApron();
            }
        }
    }

    isSZPresent (){
        if(this.props.dwdf.SZ.Values){ return true}

        return false
    }

	/**
     * render method
     * @returns {XML}
     */
	render() {

        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.dwdf')}`;
        this.props.setBreadCrumbs(breadCrumbSecond);

		return (
            <div className='row configurator-container'>
                <div className='col s12 m4 l3 xl4 div-menu-col'>
                    <div className='div-menu'>
                        <div className='vertical-line'></div>
                        <div className='above-first-step'></div>
                        <SideBarMenu
                            stepList={this.props.allSteps ? this.props.allSteps : DWDF_STEPS}
                            field='DWDF'
                            lastStep={6} />
                        <div className='below-last-step'></div>
                    </div>
                </div>
                <div className='col s12 m8 l9 xl8 step-col'>
                    <div className='step-container'>
                        {this._renderStep(this.props.step, 6)}
                        <PrevNext divClass='col s12' currentStep={this.props.step} lastStep={6} />
                    </div>
                </div>
            </div>
		);
	}

    /**
    * render relevant component for each step
    * @param step
    * @returns {XML}
    */
    _renderStep(step, lastStep) {
        switch (step) {

            case 1:
                return <StepOne articleID={this.props.articleID} lastStep={lastStep} />;
            case 2:
                return <StepTwo articleID={this.props.articleID} lastStep={lastStep} />;
            case 3:
                return <StepThree articleID={this.props.articleID} lastStep={lastStep} />;
            case 4:
                return <StepFour  articleID={this.props.articleID} lastStep={lastStep} />;
            case 5:
                return <StepFive articleID={this.props.articleID} lastStep={lastStep} />;
            case 6:
                return <Download articleID={this.props.articleID} image={dwdfImage} article='dwdf' currentStep={step} lastStep={step} />;
            default:
                return <StepOne  article='dwdf' articleID={this.props.articleID} lastStep={lastStep} />;

        }
    }

}

/**
 * Prop types
 * @type {{step: *}}
 */
Dwdf.propTypes = {
	step:           PropTypes.number.isRequired,
    setBreadCrumbs: PropTypes.func.isRequired,
};

/**
 * mapStateToProps
 * @param steps
 * @returns {{step: (number|*)}}
 */
function mapStateToProps(state) {
	return {
		step:            state.steps.currentStep,
        allSteps: state.steps.allSteps,
        apron: state.steps.apron,
		translate:       getTranslate(state.locale),
		currentLanguage: getActiveLanguage(state.locale).code,
        dwdf: state.dwdf,
	};
}

/**
 * export
 */
export default connect(mapStateToProps, actions)(Dwdf);



// WEBPACK FOOTER //
// ./src/components/Dwdf.js